export class BiggerDiscountRequestModel {
  public anno: number;
  public mese: number;
  public trimestre: string;
  public marcaId: number;
}
